import { compose } from '@bem-react/core';
import {
    Modal as ModalPresenter,
    withThemeNormal
} from '@yandex-lego/components/Modal/desktop';
import { withOutsideClick } from '@yandex-lego/components/withOutsideClick';
import { withZIndex } from '@yandex-lego/components/withZIndex';

import { withDefaultPopupScope } from 'client/common/hooks';

const Modal = compose(
    withThemeNormal,
    withOutsideClick,
    withZIndex
)(ModalPresenter);

export default withDefaultPopupScope(Modal);
